import { render, staticRenderFns } from "./PdpTileForSize.vue?vue&type=template&id=70069f0d&scoped=true&"
import script from "./PdpTileForSize.vue?vue&type=script&lang=js&"
export * from "./PdpTileForSize.vue?vue&type=script&lang=js&"
import style0 from "./PdpTileForSize.vue?vue&type=style&index=0&id=70069f0d&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70069f0d",
  null
  
)

export default component.exports